import { render } from "./save-draft.vue?vue&type=template&id=49c0cd73&scoped=true"
import script from "./save-draft.vue?vue&type=script&lang=js"
export * from "./save-draft.vue?vue&type=script&lang=js"

import "./save-draft.vue?vue&type=style&index=0&id=49c0cd73&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c0cd73"]])

export default __exports__